import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="bg"></div>
      <header className="App-header">
        {/* <div className="grow"></div> */}
        <div className="grow-1"></div>
        <h1 className='site-title'>Meuko! Meuko!</h1>
        <div className="links">
          <a href='https://naxs.notion.site/Meuko-Meuko-d83cf5454ede4939a12614b3101002ec?source=copy_link' target='_blank' rel='noreferrer'>BIO</a>
          　　/　
          <a href="mailto:meuko.meuko@gmail.com" target='_blank' rel='noreferrer'>MAIL</a>
          {/* <a href="https://www.instagram.com/meu.ko" target='_blank' rel='noreferrer'>INSTAGRAM</a> */}
          {/* <a href="https://soundcloud.com/meukomeuko" target='_blank' rel='noreferrer'>SOUNDCLOUD</a> */}
          {/* <a href="https://meukomeuko.bandcamp.com/album/ghost-island" target='_blank' rel='noreferrer'>BANDCAMP</a> */}
        </div>
        <div className="grow-2"></div>
      </header>
    </div>
  );
}

export default App;
